import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BasicModal } from '../common/modals/BasicModal';

class StatementPreferenceUpdateModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      setStatementPreferenceError: props.setStatementPreferenceError,
      setStatementPreferenceSuccess: props.setStatementPreferenceSuccess,
    };
    this._getModal = this._getModal.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      setStatementPreferenceSuccess: nextProps.setStatementPreferenceSuccess,
      setStatementPreferenceError: nextProps.setStatementPreferenceError,
    });
  }

  _getModal() {
    if (this.state.setStatementPreferenceSuccess) {
      this.props._updatePreferenceModal(true);
      return (
        <BasicModal>
          <div className="popupRect col">
            <div className="doneIconStyle">
              <span className="icon icon-done doneIconStyle" />
            </div>
            <p>{this.props.content.statementSuccess}</p>
          </div>
        </BasicModal>
      );
    } else if (this.state.setStatementPreferenceError) {
      return (
        <BasicModal>
          <div className="modalb msg-popup single-msg">
            <div className="modalb-container">
              <h5>
                Oops, there's been a problem updating some of your statement
                preferences, please try again later
              </h5>
              <p>
                When contacting support, <br />
                please quote ID: <br />
                b21ddf
              </p>
            </div>
            <div className="modalb-footer">
              <button
                className="c-btn c-btn--default"
                onClick={this.props._closeUpdatePreferenceModal}
              >
                Ok
              </button>
            </div>
          </div>
        </BasicModal>
      );
    } else {
      return <div className="loader-timeline preference-update" />;
    }
  }

  render() {
    return <div>{this._getModal()}</div>;
  }
}

StatementPreferenceUpdateModal.propTypes = {
  content: PropTypes.object,
  setStatementPreferenceError: PropTypes.bool,
  setStatementPreferenceSuccess: PropTypes.bool,
  _updatePreferenceModal: PropTypes.func,
  _closeUpdatePreferenceModal: PropTypes.func,
};

export default StatementPreferenceUpdateModal;
